import React from 'react';
import { useHistory } from 'react-router';

// Types
import { AiToolkitType, AiToolkitTypeSlugs } from './types';

// Utils
import { handleLaunchExternalLink } from 'Shared/utils/external-link';

// Constants
import { AiToolkitOptions } from './AiToolkitItems.constants';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Actions
import { createAddToWaitlist } from 'Shared/actions/Users.actions';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody, WpPageTitle } from 'Wpds/components/page-layout';
import { WpCard, WpCardBody } from 'Wpds/components/card';
import { WpButton } from 'Wpds/components/button';
import GiveFeedbackOrKudosModal from 'Shared/components/GiveFeedbackOrKudosModal/GiveFeedbackOrKudosModal';
import JoinWaitlistSuccessModal from './JoinWaitlistSuccessModal';

// Styles
import './AiToolkitPage.scss';

const AiToolkitPage = () => {
  const history = useHistory();
  const { id, isManager } = useCurrentUser();

  const [isGiveFeedbackOrKudosModalOpen, toggleIsGiveFeedbackOrKudosModalOpen] = useToggle(false);
  const [isJoinWaitlistSuccessModalOpen, toggleIsJoinWaitlistSuccessModalOpen] = useToggle(false);

  const options = isManager ? AiToolkitOptions : AiToolkitOptions.filter(item => !item.managerOnly);

  const handleItemClick = (option: AiToolkitType) => {
    if (option.to) {
      if (option.to.startsWith('/')) history.push(option.to);
      else handleLaunchExternalLink({ href: option.to });
    } else if (option.waitList) {
      createAddToWaitlist({ id, data: { feature_name: option.title } }).then(response => {
        if (response.status === 200) {
          toggleIsJoinWaitlistSuccessModalOpen();
        }
      });
    } else {
      switch (option.slug) {
        case AiToolkitTypeSlugs.feedbackAi:
          toggleIsGiveFeedbackOrKudosModalOpen();
          break;
        default:
          break;
      }
    }
  };

  const baseClassName = 'AiToolkitPage';
  return (
    <>
      <WpPageLayout className={baseClassName} width="container">
        <WpPageHeader>
          <WpPageTitle title="AI Toolkit" />
        </WpPageHeader>
        <WpPageBody>
          <div className={`${baseClassName}__grid`}>
            {options.map(option => (
              <WpCard key={option.title} className={`${baseClassName}__grid__item`}>
                <WpCardBody className={`${baseClassName}__grid__item__header`} padding={0}>
                  {option.badge && <div className={`${baseClassName}__grid__item__header__badge`}>{option.badge}</div>}
                  <img src={option.image} className={`${baseClassName}__grid__item__header__image`} />
                </WpCardBody>
                <WpCardBody className={`${baseClassName}__grid__item__body`}>
                  <h5 className={`${baseClassName}__grid__item__body__title`}>{option.title}</h5>{' '}
                  <p className={`${baseClassName}__grid__item__body__description`}>{option.description}</p>
                  <div>
                    <WpButton color="gray" onClick={() => handleItemClick(option)}>
                      {option.buttonText}
                    </WpButton>
                  </div>
                </WpCardBody>
              </WpCard>
            ))}
          </div>
        </WpPageBody>
      </WpPageLayout>
      <GiveFeedbackOrKudosModal
        flow="feedback"
        isOpen={isGiveFeedbackOrKudosModalOpen}
        toggleIsOpen={toggleIsGiveFeedbackOrKudosModalOpen}
      />
      <JoinWaitlistSuccessModal
        isOpen={isJoinWaitlistSuccessModalOpen}
        toggleIsOpen={toggleIsJoinWaitlistSuccessModalOpen}
      />
    </>
  );
};

export default AiToolkitPage;
